// src/components/profesional/EditarPerfilRedesSociales.tsx
import { useState } from 'react';
import { ButtonClose, ButtonSecundario } from '../../ui'; // Botones reutilizables
import { PopupRedesSociales } from '../../popup'; // Componente popup para añadir redes sociales
import { EditarPerfilRedesSocialesProps, RedSocial } from '@/types'; // Tipos
import { PLATFORM_LOGOS } from '../../utils/SocialConfig'; // Logos de redes sociales

// Componente para editar las redes sociales del perfil
const EditarPerfilRedesSociales: React.FC<EditarPerfilRedesSocialesProps> = ({
  redesSociales,           // Lista actual de redes sociales
  onRedesSocialesChange    // Función callback para actualizar la lista
}) => {
  const [showSocialModal, setShowSocialModal] = useState(false); // Estado para mostrar u ocultar el popup

  // Maneja la adición de nuevas redes sociales
  const handleRedesSocialesChange = (redSocial: RedSocial) => {
    // Evita duplicados: si ya existe la red social, muestra alerta
    const exists = redesSociales.some(rs => rs.nombre === redSocial.nombre);
    if (exists) {
      alert(`Ya has añadido un enlace para ${redSocial.nombre}.`);
      return;
    }

    // Si no existe, actualiza la lista de redes sociales
    onRedesSocialesChange([...redesSociales, redSocial]);
  };

  // Función para eliminar una red social de la lista
  const removeSocialLink = (index: number) => {
    const nuevasRedes = redesSociales.filter((_, i) => i !== index); // Filtra la red social seleccionada
    onRedesSocialesChange(nuevasRedes); // Actualiza la lista
  };

  return (
    <div className="redesSociale text-center">
      {/* Botón para abrir el popup de añadir red social */}
      <ButtonSecundario onClick={() => setShowSocialModal(true)}>
        Añadir Red Social
      </ButtonSecundario>

      {/* Lista de redes sociales actuales */}
      <ul className="mt-2 grid grid-cols-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-2 justify-center dark:text-zinc-900">
        {redesSociales.map((redSocial, index) => (
          <li
            key={index}
            className="flex items-center justify-between border border-zinc-700 rounded-md w-full h-6 mx-auto pr-1 bg-white"
          >
            {/* Enlace a la red social */}
            <a
              href={redSocial.enlace}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Ir a ${redSocial.nombre}`}
            >
              <img src={redSocial.iconPath} alt={redSocial.nombre} className="w-6 h-6" />
            </a>

            {/* Botón para eliminar la red social */}
            <ButtonClose onClick={() => removeSocialLink(index)} />
          </li>
        ))}
      </ul>

      {/* Popup para añadir nueva red social */}
      {showSocialModal && (
        <PopupRedesSociales
          onClose={() => setShowSocialModal(false)} // Cierra el popup
          onAddSocial={handleRedesSocialesChange}  // Función para añadir red social
          platformLogos={PLATFORM_LOGOS}           // Logos de redes sociales
        />
      )}
    </div>
  );
};

export default EditarPerfilRedesSociales;
